// extracted by mini-css-extract-plugin
export default {"main":"ServicesManagementHomeScreen_main__CPMep","body":"ServicesManagementHomeScreen_body__Lths0"};